import { IconPack } from "runtime/registry/icons/types";
import { WlConfig } from "./wlConfig";

const config: WlConfig = {
    version: '0.0.0',
    name: 'etoplatezhi',
    iconLibrary: IconPack['default'],
    components: {
        Home: {
            props: {
                isShowInstructionLink: true,
                currencyList: ['RUB'],
            },
        },
    }
};

export default config;
